import React from 'react';
import { TableCell } from '@mui/material';

import { ProcurementReportScheduleGridResponse, ProcurementReportScheduleResponse } from '@/main/models/response';

import ActionsReportSchedule from './actionsDynamicReport/actionsDynamicReport';
import * as S from './styles';
import { IEditDataSchedule } from '../../types';
import { DynamicReportGridResponse } from '@/main/models/response/dynamicReportResponse';
import ActionsDynamicReport from './actionsDynamicReport/actionsDynamicReport';

interface IRowDataDynamicReportProps {
  scheduleReport: DynamicReportGridResponse;
  refreshGrid: () => void;

}
function RowDataDynamicReport({
  scheduleReport,
  refreshGrid
}: IRowDataDynamicReportProps) {

  function handleClickRow(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) {
    e.preventDefault();
    e.stopPropagation();
  }

  return (
    <>
      <S.Container $isSizeLong onClick={handleClickRow}>
        <TableCell><S.CustomColumn title={scheduleReport.reportName}>{scheduleReport.reportName}</S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn title={scheduleReport.lastUpdate}>{scheduleReport.lastUpdate }</S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn title={scheduleReport.status}>{scheduleReport.status}</S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn><ActionsDynamicReport dynamicReport={scheduleReport} refreshGrid={refreshGrid} /></S.CustomColumn></TableCell>
      </S.Container>
    </>
  )
}
export default RowDataDynamicReport